import home from './home';
import notice from './notice';
import doctor from './doctor';
import booking from './booking';
import survey from './survey';
import testimonial from './testimonial';
import news from './news';
import blog from './blog';
import coupon from './coupon';

// El orden de este arreglo es el orden del menú. Definido por el cliente:
// Anuncios, Doctores, Reservas, Encuestas, Testimonios, Noticias, Blog, Cupones.
export default [
    ...home,
    ...notice,
    ...doctor,
    ...booking,
    ...survey,
    ...testimonial,
    ...news,
    ...blog,
    ...coupon
];
